// src/components/StudentMessages.jsx - Muro de Mensajes, Dudas y Felicitaciones
import React, { useState, useEffect } from 'react';

function StudentMessages({ currentUser }) {
  const [messages, setMessages] = useState([]);
  const [category, setCategory] = useState('felicitacion'); // 'felicitacion' | 'duda' | 'sugerencia'
  const [studentName, setFullName] = useState(currentUser?.username || '');
  const [group, setGroup] = useState(currentUser?.group || '601');
  const [messageText, setMessageText] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState('');

  // Cargar mensajes guardados
  useEffect(() => {
    const savedMessages = localStorage.getItem('eoh_student_messages');
    if (savedMessages) {
      setMessages(JSON.parse(savedMessages));
    } else {
      // Mensajes iniciales de muestra
      setMessages([
        {
          id: 1,
          name: "Ana María Gómez",
          group: "601",
          category: "felicitacion",
          text: "¡Profe Didier, me encantó la actividad del pasaporte digital y los juegos de la IA! 🥳👏",
          date: "09/08/2026"
        },
        {
          id: 2,
          name: "Felipe Echeverri",
          group: "901",
          category: "duda",
          text: "Profe, una duda sobre los verbos en pasado simple: ¿cuándo cambia la -y por -ied? Gracias 📚",
          date: "08/08/2026"
        }
      ]);
    }
  }, []);

  // Agregar emojis al texto
  const addEmoji = (emoji) => {
    setMessageText(prev => prev + emoji);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSuccessMsg('');
    setErrorMsg('');

    if (!studentName.trim() || !messageText.trim()) {
      setErrorMsg('Por favor escribe tu nombre y el mensaje.');
      return;
    }

    const newMsg = {
      id: Date.now(),
      name: studentName.trim(),
      group,
      category,
      text: messageText.trim(),
      date: new Date().toLocaleDateString()
    };

    const updated = [newMsg, ...messages];
    setMessages(updated);
    localStorage.setItem('eoh_student_messages', JSON.stringify(updated));

    setMessageText('');
    setSuccessMsg('🎉 ¡Tu mensaje ha sido publicado en el Muro EOH para el Profe Didier!');
    setTimeout(() => setSuccessMsg(''), 4000);
  };

  return (
    <div className="space-y-6 text-left">
      {/* Encabezado */}
      <div className="border-b border-slate-700 pb-4">
        <span className="text-xs font-bold text-blue-400 uppercase tracking-wider">
          Comunicación Abierta EOH
        </span>
        <h2 className="text-2xl md:text-3xl font-extrabold text-white mt-1">
          💬 Muro de Mensajes, Dudas & Felicitaciones
        </h2>
        <p className="text-slate-300 text-sm mt-1">
          Deja un mensaje para el Profesor Didier Alvarez: felicitaciones, dudas sobre las clases o sugerencias. <strong>(Sólo texto y emojis)</strong>.
        </p>
      </div>

      {/* Formulario */}
      <div className="bg-slate-800/80 border border-slate-700 p-6 rounded-3xl shadow-xl space-y-4">
        <form onSubmit={handleSubmit} className="space-y-4">
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <label className="block text-xs font-bold text-slate-300 uppercase tracking-wider mb-1">
                Tipo de Mensaje:
              </label>
              <select
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                className="w-full bg-slate-950 border border-slate-700 text-white text-sm px-4 py-2.5 rounded-xl focus:outline-none focus:border-blue-500"
              >
                <option value="felicitacion">🥳 Felicitación / Saludo</option>
                <option value="duda">❓ Duda o Inquietud</option>
                <option value="sugerencia">💡 Sugerencia para Clase</option>
              </select>
            </div>

            <div>
              <label className="block text-xs font-bold text-slate-300 uppercase tracking-wider mb-1">
                Tu Nombre Completo:
              </label>
              <input
                type="text"
                value={studentName}
                onChange={(e) => setFullName(e.target.value)}
                placeholder="Ej: Ana María Gómez"
                className="w-full bg-slate-950 border border-slate-700 text-white text-sm px-4 py-2.5 rounded-xl focus:outline-none focus:border-blue-500 placeholder-slate-500"
                required
              />
            </div>

            <div>
              <label className="block text-xs font-bold text-slate-300 uppercase tracking-wider mb-1">
                Grupo Oficial EOH:
              </label>
              <select
                value={group}
                onChange={(e) => setGroup(e.target.value)}
                className="w-full bg-slate-950 border border-slate-700 text-white text-sm px-4 py-2.5 rounded-xl focus:outline-none focus:border-blue-500"
              >
                <option value="601">Grupo 601</option><option value="602">Grupo 602</option><option value="603">Grupo 603</option>
                <option value="701">Grupo 701</option><option value="702">Grupo 702</option><option value="703">Grupo 703</option>
                <option value="901">Grupo 901</option><option value="902">Grupo 902</option><option value="903">Grupo 903</option>
              </select>
            </div>
          </div>

          {/* Barra de Emojis Rápidos */}
          <div className="flex items-center gap-1.5 flex-wrap pt-1">
            <span className="text-xs text-slate-400 font-semibold mr-1">Toca para agregar emojis:</span>
            {['🥳', '👏', '⭐', '📚', '💡', '❤️', '🇬🇧', '🙋‍♂️', '🔥', '🏆', '🎉', '😊'].map(emoji => (
              <button
                key={emoji}
                type="button"
                onClick={() => addEmoji(emoji)}
                className="bg-slate-900 hover:bg-slate-700 border border-slate-700 px-2.5 py-1 rounded-lg text-base transition active:scale-95"
              >
                {emoji}
              </button>
            ))}
          </div>

          {/* Área de Texto (SÓLO TEXTO Y EMOJIS, SIN ADJUNTOS) */}
          <div>
            <label className="block text-xs font-bold text-slate-300 uppercase tracking-wider mb-1">
              Escribe tu mensaje (Solo texto y emojis):
            </label>
            <textarea
              value={messageText}
              onChange={(e) => setMessageText(e.target.value)}
              placeholder="Escribe aquí tu felicitación o duda para el Profe Didier..."
              maxLength={300}
              rows={3}
              className="w-full bg-slate-950 border border-slate-700 text-white text-sm p-4 rounded-xl focus:outline-none focus:border-blue-500 placeholder-slate-500 resize-none"
              required
            ></textarea>
            <div className="text-right text-[10px] text-slate-400 mt-1">
              {messageText.length} / 300 caracteres máximo
            </div>
          </div>

          {errorMsg && (
            <div className="bg-red-500/10 border border-red-500/30 p-3 rounded-xl text-red-300 text-xs font-semibold">
              ⚠️ {errorMsg}
            </div>
          )}

          {successMsg && (
            <div className="bg-emerald-500/10 border border-emerald-500/30 p-3 rounded-xl text-emerald-300 text-xs font-semibold">
              {successMsg}
            </div>
          )}

          <button
            type="submit"
            className="w-full bg-blue-600 hover:bg-blue-500 text-white font-bold py-3 rounded-xl shadow-lg transition transform active:scale-95 text-sm"
          >
            ✉️ Publicar Mensaje en el Muro
          </button>
        </form>
      </div>

      {/* Muro de Mensajes Publicados */}
      <div className="space-y-4 pt-4">
        <h3 className="text-xl font-bold text-white flex items-center gap-2">
          📜 Muro de Mensajes de la Comunidad EOH ({messages.length})
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {messages.map((msg) => (
            <div 
              key={msg.id}
              className={`p-5 rounded-2xl border shadow-lg space-y-2 text-left ${
                msg.category === 'felicitacion' 
                  ? 'bg-emerald-950/40 border-emerald-500/40' 
                  : msg.category === 'duda'
                  ? 'bg-amber-950/40 border-amber-500/40'
                  : 'bg-sky-950/40 border-sky-500/40'
              }`}
            >
              <div className="flex justify-between items-center border-b border-slate-800 pb-2">
                <span className="font-bold text-white text-sm flex items-center gap-1.5">
                  <span>{msg.category === 'felicitacion' ? '🥳' : msg.category === 'duda' ? '❓' : '💡'}</span>
                  {msg.name} <span className="text-xs text-blue-400">(Grupo {msg.group})</span>
                </span>
                <span className="text-[10px] text-slate-400">{msg.date}</span>
              </div>

              <p className="text-slate-200 text-sm leading-relaxed whitespace-pre-wrap">
                {msg.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default StudentMessages;